import React, { useContext } from "react";
import { OidcProviderButton } from "./OidcProviderButton";
import useSearchParams from "@src/utils/useSearchParams";
import { useState } from "react";
import { logEvent } from "@src/utils/logClient";
import ErrorBox from "../mobile/ErrorBox";
import { TranslationContext } from "../translation/TranslationContext";
import axios from "@src/utils/requests/axiosInstance";

interface OidcContinueButtonProps {
  providerSlug: string;
}

export const OidcContinueButton: React.FC<OidcContinueButtonProps> = ({ providerSlug }) => {
  const t = useContext(TranslationContext);
  const [showOidcError, setShowOidcError] = useState(false);
  const desiredEmail = useSearchParams("email")[0];

  const handleClick = () => {
    const baseUrl = process.env.GATSBY_TEACHER_LOGIN_URL || "https://teach.classdojo.com";
    const redirectTo = `${baseUrl}/#/oidc/callback`;
    const url = `${baseUrl}/api/oidc/mobile/${providerSlug}/verification_url`;

    axios
      .get(url, {
        params: {
          redirectTo,
          email: desiredEmail,
          loginHint: desiredEmail,
          prompt: providerSlug === "google" ? "select_account consent" : undefined,
          bypassUniversalLink: "true",
        },
      })
      .then((response) => {
        window.location.href = response.data.url;
      })
      .catch((error) => {
        logEvent({
          eventName: "web.external_page.oidc.error",
          metadata: {
            provider: providerSlug,
            error: error.message,
          },
        });
        setShowOidcError(true);
      });
  };

  return (
    <>
      <button onClick={handleClick} style={{ width: "100%" }}>
        <OidcProviderButton provider={providerSlug} />
      </button>
      {showOidcError && <ErrorBox>{t.translate("components.signup_teacher.oidc_error")}</ErrorBox>}
    </>
  );
};
